export default __webpack_public_path__ + "static/wasyluk-6212e970de2f9d6d88cdf7a30c8ec648.jpg";